module.exports = __webpack_public_path__ + "static/portfolio_lcdc2_small-fs8-5af0919f32467e92df377ebfcba352ad.png";